import { Stack, styled } from '@mui/material';

export const ScheduleContainer = styled('div')(() => ({
  margin: '8px 0',
}));

export const Schedule = styled(Stack)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  padding: '16px 24px',
  display: 'inline-flex',
  borderRadius: '4px',

  '&:hover': {
    borderColor: 'var(--mui-palette-primary-main)',
  },
}));
